var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransportRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 129,
    viewBox: "0 0 173 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.524 83.4214L159.479 88.0664L164.124 96.1115L172.169 91.4665L167.524 83.4214Z",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.44 26.1301C165.51 25.7301 165.73 25.3601 166.09 25.1101L169.46 22.7601C170.18 22.2601 171.16 22.4301 171.67 23.1501C172.17 23.8701 172 24.8501 171.28 25.3601L167.91 27.7101C167.19 28.2101 166.21 28.0401 165.7 27.3201C165.45 26.9501 165.37 26.5301 165.44 26.1301Z",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.52 113.73C162.376 113.73 163.07 113.036 163.07 112.18C163.07 111.324 162.376 110.63 161.52 110.63C160.664 110.63 159.97 111.324 159.97 112.18C159.97 113.036 160.664 113.73 161.52 113.73Z",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.62 50.1797L132.22 57.9397",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.73 103.17L134.15 94.6201",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.151 12.0498L142.23 18.7598",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 102.7C20.9558 102.7 27 96.656 27 89.2002C27 81.7444 20.9558 75.7002 13.5 75.7002C6.04416 75.7002 0 81.7444 0 89.2002C0 96.656 6.04416 102.7 13.5 102.7Z",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2002 100.95C21.656 100.95 27.7002 94.906 27.7002 87.4502C27.7002 79.9944 21.656 73.9502 14.2002 73.9502C6.74435 73.9502 0.700195 79.9944 0.700195 87.4502C0.700195 94.906 6.74435 100.95 14.2002 100.95Z",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4502 90.66C13.3902 93.4 18.7903 92.44 21.5403 88.5",
    stroke: "#FA5252",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24011 78.9102L8.1001 81.1602L11.5801 80.0802L10.3201 83.5002L12.4202 86.4702L8.78015 86.3302L6.6001 89.2502L5.61011 85.7402L2.16016 84.5702L5.19006 82.5502L5.24011 78.9102Z",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3604 77.8198L17.9403 77.1398L19.4004 73.7998L21.1604 76.9898L24.7804 77.3498L22.2904 80.0098L23.0703 83.5598L19.7704 82.0198L16.6304 83.8598L17.0803 80.2398L14.3604 77.8198Z",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2799 25.2496C45.8099 24.1596 51.1799 27.7496 52.2799 33.2896C53.3699 38.8196 49.7799 44.1896 44.2399 45.2896C38.7099 46.3796 33.3399 42.7896 32.2499 37.2496C31.1499 31.7196 34.7399 26.3496 40.2799 25.2496Z",
    stroke: "#FA5252",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1099 43.6397C31.6199 42.0197 30.5499 39.9797 30.0899 37.6697C28.7599 30.9497 33.1299 24.4297 39.8499 23.0997C46.5699 21.7697 53.09 26.1397 54.42 32.8597C55.24 37.0097 53.88 41.0897 51.14 43.9197C50.69 44.3897 50.2 44.8197 49.67 45.2097",
    stroke: "#FA5252",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.66 47.4298C43.35 47.6898 42.05 47.7298 40.79 47.5798C38.69 47.3298 36.72 46.5498 35.04 45.3398",
    stroke: "#FA5252",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4 39.7402C54.67 44.5902 50.4999 48.4402 45.0799 49.5102C36.8799 51.1302 28.93 45.8002 27.3 37.6002C26.63 34.2002 27.1499 30.8302 28.5899 27.9502",
    stroke: "#FA5252",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.21 24.2198C33.29 22.0398 36.03 20.4598 39.21 19.8398C47.41 18.2198 55.37 23.5498 56.99 31.7498",
    stroke: "#FA5252",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7402 17.3701C51.2102 18.0601 57.6603 23.5701 59.1803 31.3001C61.0403 40.7101 54.9203 49.8501 45.5103 51.7101",
    stroke: "#FA5252",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2 41.5996C25.72 40.4796 25.34 39.2896 25.1 38.0496C23.28 28.8496 29.0901 19.8996 38.1501 17.7696C38.3501 17.7196 38.5601 17.6796 38.7701 17.6396",
    stroke: "#FA5252",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.13 119.349C140.13 121.189 138.64 122.669 136.8 122.669C134.96 122.669 133.47 121.179 133.47 119.349C133.47 117.509 134.96 116.029 136.8 116.029C138.65 116.019 140.13 117.509 140.13 119.349Z",
    stroke: "#FA5252",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.81 125.15C140.013 125.15 142.61 122.553 142.61 119.35C142.61 116.147 140.013 113.55 136.81 113.55C133.607 113.55 131.01 116.147 131.01 119.35C131.01 122.553 133.607 125.15 136.81 125.15Z",
    stroke: "#FA5252",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.68 119.35C145.68 124.25 141.71 128.23 136.8 128.23C131.9 128.23 127.92 124.26 127.92 119.35C127.92 114.44 131.89 110.47 136.8 110.47C141.71 110.47 145.68 114.45 145.68 119.35Z",
    stroke: "#FA5252",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5298 7.05957L69.5098 17.7096",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2197 20.0802L78.5897 1.2002",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0701 72.5293L80.0201 74.5793L79.5801 84.2493C79.5801 84.2493 87.2702 82.5993 86.6702 79.8293C86.3402 78.3193 83.1201 77.4693 85.0701 72.5293Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3404 71.4795C86.3404 71.4795 84.7205 71.7495 83.9205 74.0095C83.1205 76.2695 83.7804 79.8295 85.2204 81.0095C86.6704 82.1895 88.8204 81.5195 88.8204 81.5195L86.3404 71.4795Z",
    fill: "#C92A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2199 123.17C91.0299 123.59 80.2499 124.81 73.1099 123.21C72.7599 123.13 72.5899 122.72 72.7699 122.41L76.8298 115.37L77.1998 110.6L93.7699 111.78L95.0299 122.12C95.0899 122.63 94.7299 123.1 94.2199 123.17Z",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5199 103.159L79.5798 97.7295C79.5798 97.7295 70.2999 109.289 75.5299 117.629C75.5299 117.629 78.9799 111.189 95.1399 119.939L96.5199 103.159Z",
    fill: "#FF8787",
    stroke: "#FF8787",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1502 97.0598C84.1502 97.0598 80.0302 97.0298 79.5702 97.7298C79.1102 98.4298 78.4103 98.6098 85.0603 100.77C90.5503 102.55 95.1302 102.55 95.1302 102.55",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1502 97.0598C84.1502 97.0598 80.0302 97.0298 79.5702 97.7298C79.1102 98.4298 78.4103 98.6098 85.0603 100.77C90.5503 102.55 95.1302 102.55 95.1302 102.55",
    stroke: "#FA5252",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7402 94.1494C84.7502 94.8994 83.2302 98.8894 83.7702 98.0294C83.7702 98.0294 84.1501 99.7994 87.8201 99.7994C88.7401 99.7994 89.0302 99.4594 89.0302 99.4594",
    fill: "#C92A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8402 87.5998C85.8402 87.5998 84.1602 99.4198 93.1002 101.89C102.04 104.36 107.93 95.4098 107.95 92.4198C107.97 89.4298 104.22 86.7998 104.22 86.7998L85.8402 87.5998Z",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1998 112.149C99.1998 112.149 94.7299 115.679 95.1399 118.759C95.5499 121.839 115.43 123.499 114.36 117.939C113.29 112.379 99.1998 112.149 99.1998 112.149Z",
    fill: "#FF8787",
    stroke: "#FF8787",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8398 87.5593C85.8398 87.5593 96.3399 91.9893 104.23 86.7993L94.9598 84.5693L85.8398 87.5593Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8107 82.7899L89.1807 86.7999C89.1807 86.7999 96.2506 89.0099 100.631 85.8999V82.4199L90.8107 82.7899Z",
    fill: "#C92A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.411 90.5894C104.771 89.8494 101.851 89.3094 97.8808 91.5794C97.8808 91.5794 96.9608 98.0994 96.0508 98.9594C95.1408 99.8194 97.1408 101.159 97.1408 101.159C97.1408 101.159 106.101 100.459 107.721 93.1394C107.961 92.0794 107.381 91.0194 106.411 90.5894Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.49 119.69L113.44 123.61C113.44 123.61 113.44 124.53 103.37 125.44C93.3 126.36 95.13 124.01 95.13 124.01L96.9201 116.56C96.9201 116.56 98.35 112.7 106.12 113.42C113.88 114.15 112.49 119.69 112.49 119.69Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1405 119.94C95.1405 119.94 93.3105 116.28 100.63 114.45C107.39 112.76 114.36 119.94 114.36 119.94C114.36 119.94 115.66 104.09 108.87 97.7295C105.52 94.5995 95.1405 102.09 95.1405 102.09C95.1405 102.09 93.3105 113.54 95.1405 119.94Z",
    fill: "#FFC9C9",
    stroke: "#FFC9C9",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.87 97.9993C100.63 97.9193 100.39 97.8293 100.16 97.7393C99.2604 97.3993 98.8803 96.3193 99.3803 95.4893L99.5404 95.2193C100.13 94.2293 101.42 93.8993 102.41 94.4993L105.6 96.3993L100.87 97.9993Z",
    fill: "#C92A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1405 66.0395C95.1405 66.0395 85.9505 67.0095 84.5405 68.6895C83.1205 70.3695 87.3505 74.8795 87.0105 78.5395C86.6705 82.1995 84.2305 86.9295 94.3305 84.5695C99.9505 83.2495 102.971 83.3595 104.541 83.7195C105.481 83.9395 106.43 83.4095 106.69 82.4795C107.56 79.3195 109.151 73.2095 109.161 70.5195C109.161 66.8195 101.051 65.7695 101.051 65.7695L95.1405 66.0395Z",
    fill: "#FF8787",
    stroke: "#FF8787",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7599 68.6898C108.169 68.6898 119.85 57.0089 119.85 42.5998C119.85 28.1907 108.169 16.5098 93.7599 16.5098C79.3508 16.5098 67.6699 28.1907 67.6699 42.5998C67.6699 57.0089 79.3508 68.6898 93.7599 68.6898Z",
    fill: "#FFC9C9",
    stroke: "#FFC9C9",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2205 34.8793C93.0005 35.7393 90.5705 35.9193 88.2305 35.4693C84.3205 34.7293 79.0706 34.1193 75.9206 35.3793C70.4306 37.5693 67.6806 43.9793 70.4306 50.3893C73.1806 56.7993 76.6805 56.8893 81.3305 56.8393C85.9905 56.7893 89.8906 53.8093 96.0606 54.0493C102.921 54.3193 104.011 54.8193 109.551 54.0493C118.141 52.8593 118.511 43.0693 117.351 39.4093C116.191 35.7493 112.531 30.2593 101.551 32.9993C98.4906 33.7493 96.5005 34.3793 95.2205 34.8793Z",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8005 66.0602C71.8005 66.0602 63.5005 64.8602 61.2705 67.3202C59.0405 69.7802 58.2705 72.3502 58.2705 72.3502C58.2705 72.3502 69.3905 74.1902 71.8005 66.0602Z",
    fill: "#FFC9C9",
    stroke: "#FFC9C9",
    strokeWidth: 1.1752,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4899 54.0394C84.5326 54.0394 87.8099 50.7621 87.8099 46.7194C87.8099 42.6767 84.5326 39.3994 80.4899 39.3994C76.4471 39.3994 73.1699 42.6767 73.1699 46.7194C73.1699 50.7621 76.4471 54.0394 80.4899 54.0394Z",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4901 50.3895C83.0196 50.3895 85.0701 48.339 85.0701 45.8095C85.0701 43.28 83.0196 41.2295 80.4901 41.2295C77.9606 41.2295 75.9102 43.28 75.9102 45.8095C75.9102 48.339 77.9606 50.3895 80.4901 50.3895Z",
    fill: "#C92A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1307 45.5398C82.8874 45.5398 83.5007 44.9264 83.5007 44.1698C83.5007 43.4132 82.8874 42.7998 82.1307 42.7998C81.3741 42.7998 80.7607 43.4132 80.7607 44.1698C80.7607 44.9264 81.3741 45.5398 82.1307 45.5398Z",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.041 51.3002C111.083 51.3002 114.361 48.0229 114.361 43.9802C114.361 39.9374 111.083 36.6602 107.041 36.6602C102.998 36.6602 99.7207 39.9374 99.7207 43.9802C99.7207 48.0229 102.998 51.3002 107.041 51.3002Z",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.04 47.6395C109.57 47.6395 111.62 45.589 111.62 43.0595C111.62 40.53 109.57 38.4795 107.04 38.4795C104.511 38.4795 102.46 40.53 102.46 43.0595C102.46 45.589 104.511 47.6395 107.04 47.6395Z",
    fill: "#C92A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.681 42.7898C109.437 42.7898 110.051 42.1764 110.051 41.4198C110.051 40.6632 109.437 40.0498 108.681 40.0498C107.924 40.0498 107.311 40.6632 107.311 41.4198C107.311 42.1764 107.924 42.7898 108.681 42.7898Z",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.12 45.3494C106.877 45.3494 107.49 44.736 107.49 43.9794C107.49 43.2227 106.877 42.6094 106.12 42.6094C105.363 42.6094 104.75 43.2227 104.75 43.9794C104.75 44.736 105.363 45.3494 106.12 45.3494Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9003 48.3699C80.6569 48.3699 81.2703 47.7565 81.2703 46.9999C81.2703 46.2433 80.6569 45.6299 79.9003 45.6299C79.1436 45.6299 78.5303 46.2433 78.5303 46.9999C78.5303 47.7565 79.1436 48.3699 79.9003 48.3699Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3506 25.1898C74.3506 25.1898 77.2907 30.7098 91.9307 28.8798C106.571 27.0498 109.541 21.8398 109.541 21.8398",
    stroke: "#FA5252",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6902 72.2C58.5902 72.56 58.5303 72.92 58.5303 73.27C58.5303 76.02 64.9402 81.51 64.9402 81.51C64.9402 81.51 72.2403 86.01 74.5403 85.59C76.8403 85.17 79.5902 84.25 79.5902 84.25C80.5102 84.25 81.4203 82.42 81.4203 78.76C81.4203 75.1 77.8602 69.53 76.4402 67.74C75.8602 67 73.9702 66.42 71.8202 66.04",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6902 72.2C58.5902 72.56 58.5303 72.92 58.5303 73.27C58.5303 76.02 64.9402 81.51 64.9402 81.51C64.9402 81.51 72.2403 86.01 74.5403 85.59C76.8403 85.17 79.5902 84.25 79.5902 84.25C80.5102 84.25 81.4203 82.42 81.4203 78.76C81.4203 75.1 77.8602 69.53 76.4402 67.74C75.8602 67 73.9702 66.42 71.8202 66.04",
    stroke: "#FFC9C9",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9205 70.5195C75.9205 70.5195 74.5705 78.5195 72.2605 79.6695C68.6005 81.4995 64.0205 78.7495 64.0205 78.7495",
    stroke: "#FA5252",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.58 84.2499L72.25 79.6699",
    stroke: "#FA5252",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9706 69.6C69.9706 69.6 68.6006 71.8 72.2606 71.16C74.7806 70.72 73.8306 68.85 73.0006 67.73C72.5906 67.18 72.1907 66.63 71.8107 66.07C71.3007 65.33 70.4206 64.42 69.3606 65.02C67.6806 65.94 70.4206 67.77 69.9706 69.6Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4304 69.3501C64.7904 68.3601 64.6404 67.2601 64.0504 66.3901C62.8504 64.6201 60.7103 61.9401 59.4403 63.2101C57.6103 65.0401 61.5203 66.8401 60.4803 68.2301C59.1003 70.0701 57.6104 64.1301 57.6104 67.7901C57.6104 71.9401 59.3704 73.0001 61.2704 72.3701C63.3004 71.6801 64.0004 70.5301 64.4304 69.3501Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.041 72.3995C110.301 70.8995 109.701 69.3295 108.401 68.5295C108.211 68.4095 108.021 68.3295 107.851 68.2795C106.791 68.0095 104.421 69.1895 104.421 75.1095C104.421 81.0295 102.741 83.9395 105.351 84.2595C107.471 84.5095 109.331 76.4495 110.041 72.3995Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.63 73.6802C111.26 72.4302 110.26 71.4202 108.97 71.1702C108.01 70.9802 106.94 71.1902 106.19 72.5702C104.52 75.6302 106.55 80.8402 110.35 80.3002C113.08 79.9102 112.29 75.9002 111.63 73.6802Z",
    fill: "#C92A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.12 65.6895C126.09 65.4795 124.99 65.4995 123.89 65.8195C122.47 66.2195 121.03 66.5495 119.55 66.5995C118.4 66.6395 116.76 66.8995 114.61 67.7295C109.78 69.5995 112.52 74.1695 109.78 78.7495C107.03 83.3295 113.76 86.9695 119.09 85.6095C124.42 84.2495 131.75 80.5795 132.66 74.1795C132.85 72.8395 132.72 71.5795 132.35 70.4595",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.12 65.6895C126.09 65.4795 124.99 65.4995 123.89 65.8195C122.47 66.2195 121.03 66.5495 119.55 66.5995C118.4 66.6395 116.76 66.8995 114.61 67.7295C109.78 69.5995 112.52 74.1695 109.78 78.7495C107.03 83.3295 113.76 86.9695 119.09 85.6095C124.42 84.2495 131.75 80.5795 132.66 74.1795C132.85 72.8395 132.72 71.5795 132.35 70.4595",
    stroke: "#FFC9C9",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.361 67.7695C114.361 67.7695 111.611 72.0295 114.361 78.5995C117.111 85.1595 132.671 74.1795 132.671 74.1795",
    stroke: "#FA5252",
    strokeWidth: 1.1833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.02 72.2302C120.08 72.0802 120.48 70.7002 119.72 69.9502C119.32 69.5502 118.9 68.8802 118.64 67.7302C118.02 65.0202 115.28 68.6802 116.19 70.5102C116.74 71.6202 117.95 72.3902 119.02 72.2302Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.681 68.6897C125.451 67.6097 125.911 66.5097 126.831 65.8997C127.471 65.4697 128.241 64.8797 129.011 64.1097C130.841 62.2797 130.841 65.9397 130.261 68.6897C130.261 68.6897 131.031 67.7697 132.311 68.6897C133.591 69.6097 130.031 74.5797 130.031 74.5797C130.031 74.5797 127.481 77.2897 125.681 68.6897Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0403 124.21L47.0303 92.2598",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5902 100.54L47.0303 79.2402",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportRightImage);
export default __webpack_public_path__ + "static/media/transportRightImage.573f350b96ca4df4393ec24faeb0cbcd.svg";
export { ForwardRef as ReactComponent };